<ng-container *ngIf="client">
    <div class="client-thumb" uppDataid="clientedit-business-thumb" tabindex="0"
        (click)="OnSelect()"
        (keydown.enter)="OnSelect()"
        (keydown.space)="OnSelect(); $event.preventDefault()"
    >
        <ion-item class="info" [lines]="isPayAccount ? 'full' : 'none'">
            <ion-icon slot="start" name="storefront-outline"></ion-icon>
            <ion-label>
                <b>{{client.name}}</b><br/>
                <span class="small">
                    {{tr('@place_client_taxid')}}: <b>{{client.taxid}}</b>
                    <span *ngIf="client.address">
                        <br/>{{client.address}}
                        <ng-container *ngIf="ShowCountry; else spanishAddressInfo">
                            <span *ngIf="Country">, {{Country}}</span>
                        </ng-container>
                        <ng-template #spanishAddressInfo>
                            <span *ngIf="client.postal">, {{client.postal}}</span>
                            <span *ngIf="client.region">, {{client.region}}</span>
                        </ng-template>
                    </span>
                </span>
            </ion-label>
        </ion-item>
        <ion-item class="account" *ngIf="isPayAccount" lines="none">
            <ion-label color="primary">
                <ion-icon color="primary" name="ribbon-outline"></ion-icon>
                {{tr('@place_client_is_account')}}
            </ion-label>
        </ion-item>
    </div>
</ng-container>
